module.exports = __webpack_public_path__ + "0c590f922608edba4a0a780d6fa03c5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/clarityScale/VVS2@2x.png
// module id = 825
// module chunks = 0